import axios from 'axios';
import Vue from 'vue';
import qs from 'qs';
import roter from '../router';
// import { config } from "./config";
axios.defaults.withCredentials = true;
// 定义baseURL ，若不需要重定向，可直接从config中获取设定的值
// axios.defaults.baseURL=config.baseURL;
// axios.defaults.baseURL = '/api'; //重定向前设定替换的路径
// 请求拦截器实现
axios.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么，例如加入token
    let token = sessionStorage.getItem('token');
    token && (config.headers['Authorization'] = token);
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器实现
axios.interceptors.response.use(
  function(response) {
    // 在接收响应做些什么，例如跳转到登录页
    // tryHideFullScreenLoading()
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Vue.prototype.$message.error(error.response.data.msg);
          roter.push('/');
          sessionStorage.clear();
          break;
        default:
          Vue.prototype.$message.error(error.response.data.msg);
      }
    } else {
      //
    }
    return Promise.reject(error.response.date);
  }
);

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getUrlAppendId(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url + '/' + params.id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function postUrlAppendId(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url + '/' + params.data.id,
      headers: params.headers,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      headers: params.headers || {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      data: qs.stringify(params.data),
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function post1(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: params,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function exportFile(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url + '/' + params.data.id,
      headers: params.headers,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
